module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Built to Last")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_c('span', [_vm._v("Ephesians 2:11-22")])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We fell in love with the house. Better yet, we fell in love with the price. This home had everything. How could it be such a financial bargain? Suddenly, we found out. As we walked down a hallway, there was a sensation of moving downhill. The building had a shifting foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Much of life is as unstable as that house. “Secure” jobs evaporate in corporate downsizing. Friends move away or their values change, and they drift away from us. Even some churches divide over petty issues. How can we establish relationships that are built on a truly reliable foundation?")]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION")]), _vm._v(". Have you ever belonged to an organization which, in your judgment, failed to be what you had envisioned? Discuss what elements may have contributed to its ineffectiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTION")]), _vm._v(". Think about negative experiences you’ve had with an organization or group. How did the experience affect your future involvement with organizations or groups?")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The Christian community, according to the apostle Paul, has been built for us with strong and lasting materials. As you read, keep in mind that the first Christians were Jewish. As non-Jews (Gentiles) began to join the faith, they did not share the religious and cultural heritage of the Jewish people. The church decided very early that the "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("Jewish rite of circumcision was not necessary for a Gentile who accepted Christ ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Acts+15%3A1-21&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Acts 15:1-21")]), _vm._v("). "), _c('i', [_vm._v("Read Ephesians 2:11-22.")])])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("1. ")]), _vm._v("How would you describe Paul’s emotions about Christ and the church?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("2. ")]), _vm._v("What was the relationship between Jew and Gentile before Christ came (vv. 11-13)?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("3. ")]), _vm._v("What differences in background and culture threaten the unity of your own church?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("4. ")]), _vm._v("Explain what Paul means by the “dividing wall of hostility” (v. 14).")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("5. ")]), _vm._v("Christ himself “is our peace” (v. 14). How did he accomplish this peace (vv. 14-18)?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_c('b', [_vm._v("6. ")]), _vm._v("How do “dividing walls of hostility” keep people from hearing the gospel today?")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("7. ")]), _vm._v("What barriers stood in the way of your putting faith in Christ, and how did God overcome them?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("8. ")]), _vm._v("In verse 19 Paul compares Christians to citizens and family members. In what ways does each of these two comparisons hold true?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("9. ")]), _vm._v("In your own church, who are some people you would describe as “good citizens” or “good family members” (v. 19)?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("10. ")]), _vm._v("What building materials make up the construction described in verses 20-22?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_c('b', [_vm._v("11. ")]), _vm._v("The apostles and prophets (v. 20) can represent the New Testament and Old Testament. Why are the Scriptures vital as the foundation of our Christian community?")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("12. ")]), _vm._v("Verse 22 identifies the true resident of the “building.” How does his presence affect your attitude toward the church?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant"
  }, [_c('b', [_vm._v("13. ")]), _vm._v("In your relationship to your own church, consider ways in which you might resemble a pile of stones lying off to one side, instead of an integral part of the building. How will you become a more functional part of this dwelling place of God that is under construction (v. 21)?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Pray that your church will grow into the kind of spiritual temple that Paul evokes. Pray especially that your own involvement in the church will further that growth.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Now or Later")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This week try to be aware of what sort of “brick” or “stone” you are in the spiritual dwelling which is the church. Ask yourself, "), _c('i', [_vm._v("Am I too much of an individual, not fitting into the whole? Do I take on too great a role as though I want to control the entire building? Do I appreciate the value of the other parts of the building?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 66
// module chunks = 0